import React, { useContext } from 'react'
import { DataContext } from '../../../context/DataContext'
import { Role } from '../../../api/schemas/schema'

type RoleGuardProps = {
   children: React.ReactNode
   allowedRoles: Role[]
}
export const RoleGuard = ({ allowedRoles, children }: RoleGuardProps) => {
   const dataContext = useContext(DataContext)
   const { userAccount } = dataContext.state

   const isAllowed = !!userAccount && allowedRoles.some((allowedRole) => userAccount.role === allowedRole)

   return isAllowed ? <>{children}</> : null
}
